import withIcon from './NewIcon';
// @ts-ignore
import IconWebsite from './icon/l/globe.svg';

export default withIcon(IconWebsite);
